import StatusTag from "../../components/buttons/StatusTag";
import {
  getContentIcon,
  formatDate,
} from "../utils/DashboardUtils";
import getDecision from "./GetDecision";

const addOneYear = (value) => {
  const baseDate = value?.toDate
    ? value.toDate()
    : value
      ? new Date(value)
      : null;

  if (!baseDate || Number.isNaN(baseDate.getTime())) return null;
  const next = new Date(baseDate);
  next.setFullYear(next.getFullYear() + 1);
  return next;
};

function SubmissionRow({ submission, isAdminView = false, isActive, onClick }) {
  const {
    contentType,
    mediaTypes,
    productTypes,
    title,
    referenceNumber,
    createdAt,
    approvalDate,
    expiryDate,
    approvedAt,
    expiredAt,
    reviewedAt,
    completedAt,
    updatedAt,
    ownerEmail,
    createdByEmail,
    status,
    attemptCount, //  show this, but still ONE row
  } = submission || {};

  const submittedBy = createdByEmail || ownerEmail || "";

  const resolvedDecision = getDecision(status);
  const decisionLabel =
    resolvedDecision === "Unknown" ? "Awaiting Response" : resolvedDecision;
  const mediaTypeLabel = Array.isArray(mediaTypes)
    ? mediaTypes.filter(Boolean).join(", ")
    : typeof mediaTypes === "string"
      ? mediaTypes
      : "";
  const productTypeLabel = Array.isArray(productTypes)
    ? productTypes.filter(Boolean).join(", ")
    : typeof productTypes === "string"
      ? productTypes
      : "";
  const displayType =
    mediaTypeLabel || contentType || productTypeLabel || "Content";

  const isApproved = decisionLabel === "Approved";

  const approvalDateValue = isApproved
    ? approvalDate ||
      approvedAt ||
      reviewedAt ||
      updatedAt ||
      completedAt ||
      null
    : null;
  const expiryDateValue =
    (isApproved ? expiryDate : null) ||
    (isApproved ? expiredAt : null) ||
    (approvalDateValue ? addOneYear(approvalDateValue) : null);

  return (
    <button
      type="button"
      className={`fp-submission-row ${isActive ? "is-active" : ""}`}
      onClick={onClick}
    >
      <div className="fp-submission-icon">
        <span
          className={`fp-submission-icon-inner fp-submission-icon-inner--${decisionLabel.toLowerCase().replace(/\s+/g, "-")}`}
        >
          {getContentIcon(displayType)}
        </span>
      </div>

      <div className="fp-submission-main">
        {/* <div className="fp-submission-type">{productTypes || ""}</div> */}
        <div className="FP_Content">{displayType}</div>
        <div className="FP_Body_Semibold">
          {title || ""}

          {/* attempts shown as meta, not separate rows */}
          {/* {typeof attemptCount === "number" && attemptCount > 1 && (
            <span className="fp-attempt-badge">Attempts: {attemptCount}</span>
          )} */}
        </div>

        <div className="fp-submission-meta">
          <div className="fp-meta-col">
            <div className="fp-meta-label FP_Content">Reference</div>
            <div className="fp-meta-value FP_Content">
              {referenceNumber || `${submission?.id}`}
            </div>
          </div>

          <div className="fp-meta-col">
            <div className="fp-meta-label FP_Content">Submitted</div>
            <div className="fp-meta-value FP_Content">
              {formatDate(createdAt)}
            </div>
          </div>

          {submittedBy  && (
            <div className="fp-meta-col">
              <div className="fp-meta-label FP_Content">Submitted By</div>
              <div className="fp-meta-value FP_Content">{submittedBy}</div>
            </div>
          )}

          {(approvalDateValue || expiryDateValue) && (
            <>
              <div className="fp-meta-col">
                <div className="fp-meta-label FP_Content">Approval</div>
                <div className="fp-meta-value FP_Content">
                  {formatDate(approvalDateValue)}
                </div>
              </div>

              <div className="fp-meta-col">
                <div className="fp-meta-label FP_Content">Expiry</div>
                <div className="fp-meta-value FP_Content">
                  {formatDate(expiryDateValue)}
                </div>
              </div>
            </>
          )}
        </div>
        <div className="fp-meta-link FP_Content">View Approval Conditions</div>
      </div>
      <StatusTag status={decisionLabel} />
      {/* <div className="fp-submission-status">
        <span className={`fp-status-chip ${chip.tone}`}>{chip.label}</span>
      </div> */}
    </button>
  );
}

export default SubmissionRow;
